import Api from "../../../util/Api";

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új anyag',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            }, {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-copy"></i>',
                title: 'Másolás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'copyRow'
            }, {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            }, {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                sort: true,
                visibility: false,
                formType: 'number',
            },
            {
                name: "code",
                label: "Kód",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
                formType: 'text',
                formSize: 2,
                formVisible: true,
                formRequired: true
            },
            {
                name: "type",
                label: "Típus",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formType: 'text',
                formSize: 2,
                formVisible: true,
                formRequired: true
            },
            {
                name: "name",
                label: "Anyag neve",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
                formType: 'text',
                formSize: 2,
                formVisible: true,
                formRequired: true
            },
            {
                name: "amount",
                label: "Mennyiség",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formType: 'number',
                formSize: 2,
                formVisible: true,
                formRequired: true
            },
            {
                name: "amountUnit.text",
                label: "Mennyiségi egység",
                filter: {
                    type: "simple",
                },
                visibility: true,
            },
            {
                name: "amountUnitId",
                label: "Mennyiségi egység",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getMaterialInstrumentAmountUnit,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: "id",
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 2,
                formVisible: true,
                formRequired: true
            },
            {
                name: "deleted",
                label: "deleted",
                filter: {
                    type: "simple",
                },
                formType: 'number',
                visibility: false
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                filter: {
                    type: "simple",
                },
                formType: 'text',
                visibility: false
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                filter: {
                    type: "simple",
                },
                formType: 'date',
                visibility: false
            },
            {
                name: "createdBy",
                label: "createdBy",
                filter: {
                    type: "simple",
                },
                formType: 'text',
                visibility: false
            },
            {
                name: "createdOn",
                label: "createdOn",
                filter: {
                    type: "simple",
                },
                formType: 'date',
                visibility: false
            },
            {
                name: "companyId",
                label: "Cég",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'number'
            },
            {
                name: "siteId",
                label: "Telephely",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getCompanySitesByCompanyId,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'keresés',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 2,
                formRequired: true,
                formVisible: true
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
